import React from 'react';

import { Button } from '@bringg/react-components';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring-shared';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from './filter-button.module.scss';

interface Props {
	onClick: () => void;
	filterObjectCount: number;
}

const FilterButton = ({ filterObjectCount, onClick }: Props) => {
	const { filters } = useRoutesMonitoringTranslations();

	return (
		<Button
			data-test-id="toggle-filters"
			className={styles.filterBtn}
			type="regular"
			onClick={onClick}
			icon={<BringgIcon iconName={BringgFontIcons.FilterList} />}
		>
			{filters} {filterObjectCount > 0 && <span className={styles.label}>{filterObjectCount}</span>}
		</Button>
	);
};

export default FilterButton;
